import InterestRegistration from '../../../structures/InterestRegistration';
import Api from '../../../util/Api';
import ModuleConfig from '../Config';

const actions = ModuleConfig.Actions;
const endpoints = ModuleConfig.Endpoints;
const CRUDActions = ModuleConfig.CRUDActions;

export function getInterestRegistrations(opts = { start: 0, limit: 20 }) {
    return CRUDActions.getAll(actions.getAll, {
        ...opts,
        endpoint: endpoints.interestRegistrations,
        mapStructure: InterestRegistration,
        errorNotification: "Înregistrările nu au putut fi încărcate"
    });
}

export function getInterestRegistration(id) {
    return CRUDActions.getOne(actions.getOne, {
        id,
        endpoint: endpoints.interestRegistration,
        mapStructure: InterestRegistration,
        errorNotification: "Înregistrarea nu a putut fi încărcată"
    })
}

export function updateInterestRegistration(id, values) {
    return CRUDActions.update(actions.edit, {
        id,
        values,
        endpoint: endpoints.interestRegistration,
        mapStructure: InterestRegistration,
        successNotification: "Înregistrarea a fost modificată",
        nextUrl: '/interest-registrations/',
    })
}

export function updateStatus(id, status, notes) {
    return CRUDActions.update(actions.updateStatus, {
        id,
        values: { status, notes },
        endpoint: endpoints.updateStatus,
        mapStructure: InterestRegistration,
        successNotification: "Statusul a fost actualizat",
    })
}

export function deleteInterestRegistration(id) {
    return CRUDActions.remove(actions.delete, {
        id,
        endpoint: endpoints.interestRegistration,
        successNotification: "Înregistrarea a fost ștearsă",
        nextUrl: '/interest-registrations'
    });
}

export async function runLottery(campaignId, count) {
    const endpoint = endpoints.runLottery.replace('[campaignId]', campaignId);
    return Api.post(endpoint, {}, {}, { count });
}

export async function getSelectedEmails(campaignId) {
    const endpoint = endpoints.selectedEmails.replace('[campaignId]', campaignId);
    return Api.get(endpoint, {}, {});
}
